
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thank-you-for-applying-job",
      function () {
        return require("private-next-pages/thank-you-for-applying-job.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thank-you-for-applying-job"])
      });
    }
  